import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import Voucher from '../components/Transfers/Voucher';
import { urlVoucher } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
import { sendMobile } from '../functions/mobile';
import { feathersCreateData } from '../services';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';

const VoucherServicePayContainer = props => {
    const { classes, balances, user, handleOpenSnack } = props
    const [ codespaginate, setCodesPaginate ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    const [ loading, setLoading ] = useState(false)
    const [ dialog, setDialog ] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))
    const [accountSelected, setAccountSelected ] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')

            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.Codigo)
        }
        return unmount()
    }

    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {

        setLoading(true)

        findTransferCore({
            $limit: 10,
            $skip : rows,
            type: {
                $in: [ 27, 29 ]
            },
            state : true,
            name: secuencial,
            createdAt: {
                $lte: valuedateEnd,
                $gte: valuedateStart
            },
            $sort: {
                createdAt: -1
            }
        }).payload.then(
            response => {

                //console.log(response)

                const { data, total } = response

                convertJsonToData(data, total, numberpage)

                setLoading(false)
            }
        ).catch(
            error => {
                //console.log(error)
                setLoading(false)
            }
        )
    }

    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];

        data.forEach(row => {
            
            try {
                
                let transfertjson = JSON.parse(row.response);
                //console.log(transfertjson)
                (transfertjson.UuidTransaccion) && resul.push(transfertjson);

            } catch (error) {
                //console.log(error)
            }
        
        })

        //console.log("TODOS LOS MOVIMIENTOS: ", resul)

        setCodesPaginate(resul)

        getDataViewTable(total, numberpage);
            
    }

    useEffect(mount, []) 

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    

    const handleSubmit = (val) => {
        // console.log(val)
    }
    // mayor

    const getDataViewTable = (total, numberpage) => {
    
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if(residuo > 0){
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        //setAllCodes([])
        //console.log(allcodes)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.Codigo)
        
    }

    

    const handleResendEmailWithVoucher = (row) => {

        let object_send_email_with_voucher = {}

        const { CorreoElectronico } = user;

        setLoading(true)

            if(row.IdentificacionDeudor){
    
                object_send_email_with_voucher = {
                    Documento : "voucher_"+row.DocumentoTransaccion,
                    Email : CorreoElectronico,
                    DataVoucher : {
                        Documento : row.DocumentoTransaccion,
                        Valor : row.MontoPagar,
                        TipoServicio : row.Servicio,
                        NombreInstitucion : row.NombreInstitucion,
                        Referencia : row.NumeroDeReferencia,
                        Identificacion : row.IdentificacionDeudor,
                        Nombre : row.NombreDeudor,
                        NumeroCliente : row.NroDeCliente,
                        Cliente : row.NombreCliente,
                        NumeroCuentaOrigen : row.NroDeCuenta,
                        Rubros : row.Rubros,
                        Monto : row.Monto,
                        Comision : row.Comision,
                        Fecha : row.FechaPago,
                        Concepto : row.Concepto,
                        UrlFactura : row.UrlFactura,
                        Factura : row.Factura
                    },
                    Type : 29 
                }

            }else{

                object_send_email_with_voucher = {
                    Documento : "voucher_"+row.DocumentoTransaccion,
                    Email : CorreoElectronico,
                    DataVoucher : {
                        Valor : row.MontoPagar,
                        Servicio : row.Servicio,
                        Institucion : row.NombreServicio,
                        Referencia : row.NumeroDeReferencia,
                        Cliente : row.NombreCliente,
                        NumeroCuentaOrigen : row.NroDeCuenta,
                        NumeroCliente : row.NroDeCliente,
                        Fecha : row.FechaPago,
                        Documento : row.DocumentoTransaccion,
                        Concepto : row.Concepto,
                        UrlFactura : row.UrlFactura,
                        Factura : row.Factura,
                        Monto : row.Monto,
                        Comision : parseFloat(row.Comision).toFixed(2)
                    },
                    Type : 27 
                }

            
        }

        //console.log(object_send_email_with_voucher)
        sendEmailWithVoucher(object_send_email_with_voucher).payload.then(
            response => {
                // console.log(response)
                setLoading(false)
                handleOpenSnack(response.message, response.type)
            }
        ).catch(
            error => {
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
                setLoading(false)
            }
        )
    }

    const onChangePaginationCodes = (e, numberpage) => {
    
        handleGetDataMovementsBySecuencialAccount((numberpage - 1)*10, dateStart, dateEnd, numberpage, accountSelected.Codigo);
        //setTransactionPaginate(datacodespaginate)
        //setPage(numberpage)
    }

    //handle
    const handleSelectCode = (val) => {
        // console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
            
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)

                let selectMonth = new Date(obj.year, obj.month, 1)
                
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                //filterCodesByDate(dateStart, dateEnd, allcodes)
                setDateValue(val)
                setLoading(false)
                handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1, accountSelected.Codigo)
        }
        
    }
    const handleFindRange = () => {
        
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.Codigo)
        
    }

    const handleViewVoucher = (row) => {
        //console.log("MOVIMIENTO SELECCIONADO: ", row)

            if(row.IdentificacionDeudor){
    
                setDialog({open: true, title: 'Comprobante',
                children:   <Voucher
                                amount ={ parseFloat(row.MontoPagar).toFixed(2) }
                                titleheader = { "Valor cancelado" }
                                title = { "Comprobante" }
                                textButtonCancel = { "Cancelar" }
                                handleCancel = { handleCLoseDialog }
                                databodyone = { [
                                    {
                                        title : "Servicio:",
                                        value : row.Servicio,
                                        order : 1
                                    },
                                    {
                                        title : "Convenio:",
                                        value : row.NombreInstitucion,
                                        order : 2
                                    },
                                    {
                                        title : "Referencia:",
                                        value : row.NumeroDeReferencia,
                                        order : 3
                                    },
                                    {
                                        title : "Identificación:",
                                        value : row.IdentificacionDeudor,
                                        order : 4
                                    },
                                    {
                                        title : "Deudor:",
                                        value : row.NombreDeudor,
                                        order : 5
                                    },
                                    {
                                        title : "Rubro:",
                                        value : row.Rubros,
                                        order : 6
                                    },
                                    {
                                        title : "Factura:",
                                        value : row.Factura,
                                        order : 7
                                    },
                                    {
                                        title : "# Socio:",
                                        value : row.NroDeCliente,
                                        order : 8
                                    },
                                    {
                                        title : "Socio:",
                                        value : row.NombreCliente,
                                        order : 9
                                    },
                                    {
                                        title : "Número de Cuenta:",
                                        value : row.NroDeCuenta,
                                        order : 10
                                    },
                                    {
                                        title : "Fecha:",
                                        value : moment(row.FechaPago).format("YYYY/MM/DD"),
                                        order : 11
                                    },
                                    {
                                        title : "Concepto:",
                                        value : row.Concepto,
                                        order : 12
                                    },
                                    {
                                        title : "Dcto. de transacción:",
                                        value : "# "+row.DocumentoTransaccion,
                                        order : 13
                                    }
                                ] }
                                
                                onActionAfter = {() => history.push('/')}
                                handleCancelTransferForm = {handleCLoseDialog} 
                                handleDownloadVoucher = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.DocumentoTransaccion, name_voucher: row.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                let namefile = res.name_voucher
                                                if (localStorage.caja_app !== undefined) {
                                                    // let send = {
                                                    //     type: 'action',
                                                    //     action: 'download_voucher',
                                                    //     data: urlVoucher+namefile+".pdf",
                                                    //     messageSend: 'Pago de servicios'
                                                    // }
                                                    // sendMobile(JSON.stringify(send))

                                                    handleDownloadMovil(urlVoucher, namefile)
                                                } else {
                                                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                                                    handleDownloadWeb(urlVoucher, namefile)
                                                }
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                        
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                handleDownloadDevice = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.DocumentoTransaccion, name_voucher: row.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                let namefile = res.name_voucher
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+namefile+".pdf",
                                                    nameFile: namefile,
                                                    extension: 'pdf',
                                                    messageSend: 'Pago de servicios'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                        
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                handleSendEmailWithVoucher = { () => { handleResendEmailWithVoucher(row) }}
                                typesizegrid = {12}
                            />
                            })
            }else{
    
                setDialog({open: true, title: 'Comprobante',
                children:   <Voucher
                                amount = { parseFloat(row.MontoPagar).toFixed(2) }
                                titleheader = { "Valor cancelado" }
                                title = { "Comprobante" }
                                databodyone = {
                                    [
                                        {
                                            title : "Servicio:",
                                            value : row.Servicio,
                                            order : 1
                                        },
                                        {
                                            title : "Institución:",
                                            value : row.NombreInstitucion,
                                            order : 2
                                        },
                                        {
                                            title : "Número de Celular:",
                                            value : row.NumeroDeReferencia,
                                            order : 3
                                        },
                                        {
                                            title : "Socio:",
                                            value : row.NroDeCliente,
                                            order : 4
                                        },
                                        {
                                            title : "Cliente:",
                                            value : row.NombreCliente,
                                            order : 5
                                        },
                                        {
                                            title : "Número de Cuenta:",
                                            value : row.NroDeCuenta,
                                            order : 6
                                        },
                                        {
                                            title : "Comisión:",
                                            value : "$ "+parseFloat(row.Comision).toFixed(2),
                                            order : 7
                                        },
                                        {
                                            title : "Fecha:",
                                            value : moment(row.FechaPago).format("YYYY/MM/DD"),
                                            order : 8
                                        },
                                        {
                                            title : "Concepto:",
                                            value : row.Concepto,
                                            order : 9
                                        },
                                        {
                                            title : "Dcto. de transacción:",
                                            value : "# "+row.DocumentoTransaccion,
                                            order : 10
                                        },
                                        {
                                            title : "Factura:",
                                            value : row.Factura,
                                            order : 11
                                        }
                                    ]
                                }
                                onActionAfter = {() => history.push('/')}
                                handleCancelTransferForm = {handleCLoseDialog} 
                                handleDownloadVoucher = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.DocumentoTransaccion, name_voucher: row.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                let namefile = res.name_voucher
                                                if (localStorage.caja_app !== undefined) {
                                                    // let send = {
                                                    //     type: 'action',
                                                    //     action: 'download_voucher',
                                                    //     data: urlVoucher+namefile+".pdf",
                                                    //     messageSend: 'Comprobante Credito'
                                                    // }
                                                    // sendMobile(JSON.stringify(send))
                                                    handleDownloadMovil(urlVoucher, namefile)
                                                } else {
                                                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                                                    handleDownloadWeb(urlVoucher, namefile)
                                                }
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                        
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                handleDownloadDevice = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.DocumentoTransaccion, name_voucher: row.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                let namefile = res.name_voucher
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+namefile+".pdf",
                                                    nameFile: namefile,
                                                    extension: 'pdf',
                                                    messageSend: 'Pago de servicios'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )

                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                handleSendEmailWithVoucher = { () => { handleResendEmailWithVoucher(row) }}
                                typesizegrid = {12}
                            />
                            })
            }
        
    }
    const handleCLoseDialog  = () => {
        setDialog({...dialog, open: false})
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha</Th>
                                        <Th>Socio</Th>
                                        <Th>Institución</Th>
                                        <Th className = { "colunmvalue"}>Monto</Th>
                                        <Th>Rubro</Th>
                                        <Th>Comprobante</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        codespaginate.map(row => (
                                            <Tr key={`${ (row.Documento) ? row.Documento : row.DocumentoTransaccion }-${ (row.Fecha) ? row.Fecha : row.FechaPago }`}>
                                                <Td>{ moment(row.FechaPago).format("YYYY/MM/DD") }</Td>
                                                <Td>{ (row.NombrePagador) ? row.NombrePagador : row.NombreCliente }</Td>
                                                <Td>{row.NombreInstitucion}</Td>
                                                <Td>$ { (row.Valor) ? row.Valor : row.MontoPagar }</Td>
                                                <Td>{ (row.Rubro) ? row.Rubro : row.Rubros }</Td>
                                                <Td><Button variant="contained"
                                                        onClick = {() => handleViewVoucher(row)}
                                                        fullWidth
                                                        style= {{
                                                            fontSize: '0.6rem',
                                                            color: '#1a1919',
                                                            borderLeft: '3px solid rgba(255, 198, 0)',
                                                            backgroundColor: "white",
                                                            borderRadius: '0px',
                                                            fontFamily: 'Ubuntu',
                                                            fontWeight: 'bold'
                                                        }}>Ver</Button></Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCodes }
                            />
                        </Grid>
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado pago de servicios en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Detalle de pago de servicios de la Cuenta </Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                            
                        </Grid>
                    </Grid>
                    <SelectForm
                        name = { 'Periodo' }
                        label = { 'Seleccione periodo '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectCode(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container spacing={3} justify="center" alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    const renderHeader = () => {
        return  <div>
                    <FormControl variant="outlined" style={{maxWidth: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                        <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={balances[0]}
                        onChange={(e) => handleAccountFind(e.target.value) }
                        >
                            {
                                balances.map(option => {
                                return <MenuItem key={option.Codigo} value={option}>{`${option.Codigo} - ${option.Tipo}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                info = { renderHeader()}
                multiple = { true }
                panel = {2}
            />
            <LoadingScreen open={loading} />
            <StandardDialog 
                handleClose = {handleCLoseDialog}
                open = {dialog.open}
                title = {dialog.title}>
                   { dialog.children }
            </StandardDialog> 
        </div>
    );
};

VoucherServicePayContainer.propTypes = {
    balances: PropTypes.array.isRequired,
};

export default connect(null , { getCodes, sendEmailWithVoucher, findTransferCore })(VoucherServicePayContainer);

//export default VoucherServicePayContainer;